export class Alert {
    type: AlertType;
    message: string;
    icon: string;
    alertId: string;
    keepAfterRouteChange: boolean;

    constructor(init?:Partial<Alert>) {
        Object.assign(this, init);
    }
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/classes/Alert.ts